import { render } from "./HomeUserInfo.vue?vue&type=template&id=be1b1d54&scoped=true"
import script from "./HomeUserInfo.vue?vue&type=script&lang=js"
export * from "./HomeUserInfo.vue?vue&type=script&lang=js"

import "./HomeUserInfo.vue?vue&type=style&index=0&id=be1b1d54&scoped=true&lang=css"

import exportComponent from "D:\\eazyc\\ezDev\\ECS-Cognitive\\cognitive-screening-mobile-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be1b1d54"]])

export default __exports__